// extracted by mini-css-extract-plugin
export default {"root":"ReturnButton_root__Z9ivR","layout-container":"ReturnButton_layout-container__S0rY-","returnButton":"ReturnButton_returnButton__JQjgY","returnButtonImg":"ReturnButton_returnButtonImg__bPpht","returnButtonText":"ReturnButton_returnButtonText__ahi4i"};
    if(module.hot) {
      // 1763464084387
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  